/**
 * IngLogo — the ING brand wordmark (orange #FF6200) used wherever we
 * reference the ING partnership: the navbar "Vragen" link, the homepage
 * trust strip, and the /ing hub hero.
 *
 * Rendered from a bundled SVG wordmark (no box) so it reads as the ING
 * logo rather than a CSS pill badge (Dennis 2026-06-03). If an official
 * ING logo asset is dropped in at the same path it swaps in transparently.
 *
 * `height` is in px; width scales from the SVG aspect ratio. Plain <img>
 * (not next/image) keeps the inline SVG crisp without image-optimizer SVG config.
 */
export default function IngLogo({ height = 22, className = "" }) {
  return (
    <img
      src="/images/ing-logo-lion.svg"
      alt="ING"
      height={height}
      style={{ height: `${height}px`, width: "auto" }}
      className={className}
    />
  );
}
